import { Panel } from "@xyflow/react";
import { useEffect, useState } from "react";
import { useAtomValue } from "jotai";
import { togglesAtom, zslHasDraftNodesAtom } from "@zapier/canvas-state";

import styles from "./DiagrammingToolbar.module.css";
import { CursorOptions } from "./CursorOptions";
import { BasicNodeOptions } from "./BasicNodeOptions";
import { AppNodeOptions } from "./AppNodeOptions";

export function DiagrammingToolbar() {
  const [showDiagrammingToolbar, setShowDiagrammingToolbar] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowDiagrammingToolbar(true);
    }, 1500);
  }, []);

  const zslHasDraftNodes = useAtomValue(zslHasDraftNodesAtom);
  const toggles = useAtomValue(togglesAtom);

  if (zslHasDraftNodes) {
    return null;
  }

  return (
    <Panel
      position="bottom-center"
      className={`${styles.toolbar} ${
        showDiagrammingToolbar ? styles.toolbarVisible : ""
      }`}
    >
      <div
        role="toolbar"
        aria-label="Shortcuts toolbar"
        className={styles.appListContainer}
        data-id="appsListContainer"
      >
        <div className={styles.section}>
          <div className={styles.sectionHeader}>Cursor</div>
          <CursorOptions isDisabled={zslHasDraftNodes} />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>Basic</div>
          <BasicNodeOptions isDisabled={zslHasDraftNodes} />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>Zapier Assets</div>
          <AppNodeOptions
            isDisabled={toggles.aiCanvasComposer ? false : zslHasDraftNodes}
          />
        </div>
      </div>
    </Panel>
  );
}
